import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/LaC_logo_duo_header.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header-logo-div" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-header",
    src: _imports_0
  })
], -1)
const _hoisted_2 = { class: "header-text-containter" }
const _hoisted_3 = ["href", "target"]
const _hoisted_4 = { class: "default-text-header header-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerHamburger = _resolveComponent("headerHamburger")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-header navbar", { 'navbar--hidden': !_ctx.showNavbar }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerSections, (section, index) => {
        return (_openBlock(), _createElementBlock("a", {
          key: index,
          href: section.url,
          target: section.target
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(section.text), 1)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createVNode(_component_headerHamburger, { headerSections: _ctx.headerSections }, null, 8, ["headerSections"])
  ], 2))
}